import { Inject } from '@odinjs/odin';

import { Attachment, DownloadService, Endpoint, TokenUtils } from '@philips-emr/hpms-provider-commons';
import { FetchAPI, FieldAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';

import { CallDetailsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface CallDetails {
  dtClose?: string,
  reasonForCancellation?: string,
}

@Controller({ fragment: FragmentNames.CALL_DETAILS })
export default class CallDetailsController extends BaseController {

  @Inject(Aliases.PANEL_HISTORY)
  private panelHistory: PanelAPI;
  @Inject(Aliases.FIELD_CANCEL_DATE)
  private fieldCancelDate: FieldAPI;
  @Inject(Aliases.FIELD_CANCEL_REASON)
  private fieldCancelReason: FieldAPI;
  @Inject(Aliases.FIELD_ANEXOS)
  private fieldAttachments: FieldAPI;

  @OnMount(Aliases.PANEL_CALL_DETAILS)
  onMountMainPanel(): void {
    const { nrSeqCall } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqCall });
  }

  @OnAfterFetch(Aliases.FETCH_CALL)
  onAfterFetchProviders(event: FetchEvent): void {
    const data = event.data as CallDetails;
    this.fieldCancelDate.setVisible(!data.dtClose ? false : true);
    this.fieldCancelReason.setVisible(!data.reasonForCancellation ? false : true);
  }

  @OnAfterFetch(Aliases.FETCH_ATTACHMENTS)
  onAfterFetchAttachments(event: FetchEvent): void {
    const data = event.data as FetchAPI;
    this.fieldAttachments.setVisible(data.length <= 0 ? false : true);
  }

  @OnAfterFetch(Aliases.FETCH_HISTORY)
  onAfterFetchHistory(event: FetchEvent): void {
    const data = event.data;
    if (!data) {
      this.panelHistory.setVisible(false);
    }
  }

  @OnSelect(Aliases.ATTACHMENTS_LIST)
  onSelectAttachment(event: SelectEvent<Attachment>): void {
    const { value } = event;
    const { nrSeqAttachment, dsFile } = value;
    const { nrSeqWSuiteUser } = TokenUtils.getValues();

    DownloadService.of({
      endpoint: Endpoint.GET.CALLS_ATTACHMENTS,
      name: dsFile,
      parameters: { nrSeqAttachment, nrSeqWSuiteUser },
    });
  }

}
